import { reject } from "lodash-es"

export default function (_this) {
  return {
    dashboard (uid, dash, callback) {
      _this.accessRef
        .child('Dashboard')
        .child(uid + '/' + dash)
        .on('value', (snapshot) => {
          callback(snapshot.val() || {})
        })
    },
    admin (uid, callback) {
      _this.accessRef
        .child('Admin')
        .child(uid)
        .on('value', (snapshot) => {
          callback(snapshot.val() || {})
        })
    },
    /**
     * Read access rules
     * @returns {Object}
     */
    async read (cb) {
      const access = {}
      const initial = true

      await new Promise((resolve) => {
        _this.accessRef.child('Dashboard').once('value', (snapshot) => {
          access['Dashboard'] = snapshot.val() || {}

          if (!initial) cb(access)

          resolve()
        })
      })

      await new Promise((resolve) => {
        _this.accessRef.child('Admin').once('value', (snapshot) => {
          access['Admin'] = snapshot.val() || {}

          if (!initial) cb(access)

          resolve()
        })
      })

      this.initial = false

      cb(access)
    },
    /**
     * Set admin access rule for given user id
     * @param {string} uid - user id
     */
    setUserAsAdmin (uid) {
      return new Promise((resolve) => {
        _this.root.ref(`access/Admin/${uid}`).set({ all: true }, (err) => {
          if (err) {
            console.error(err)
            reject(err)
          } else {
            resolve()
          }
        })
      })
    },
    /**
     * Remove admin right for given user id
     * @param {string} uid - user id
     */
    removeUserAdminRight (uid) {
      return new Promise((resolve) => {
        _this.root.ref(`access/Admin/${uid}`).remove((err) => {
          if (err) {
            console.error(err)
            reject(err)
          } else {
            resolve()
          }
        })
      })
    },
    async saveDashboardAccess ({ uid, dId, rules }) {
      await new Promise((resolve) => {
        _this.root.ref(`/dashboards/${dId}/sharedWith/${uid}`).set(true, () => {
          resolve()
        })
      })

      await new Promise((resolve) => {
        _this.accessRef.child(`Dashboard/${uid}/${dId}`).set(rules, () => {
          resolve()
        })
      })
    },
    async removeDashboardAccess ({ uid, dId }) {
      await new Promise((resolve) => {
        _this.root.ref(`/dashboards/${dId}/sharedWith/${uid}`).remove(() => {
          resolve()
        })
      })
      
      await new Promise((resolve) => {
        _this.accessRef.child(`Dashboard/${uid}/${dId}`).remove(() => {
          resolve()
        })
      })
    }
  }
}
